
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiSetMealDetail, apiSetMealAdd, apiSetMealEdit, apiMealModule } from '@/api/shop'
import { throttle } from '@/utils/util'
import config from '@/config'
@Component
export default class SetMealEdit extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前编辑用户的身份ID

  // 添加商城表单数据
  form: any = {
    name: '', // 名称
    explain: '',
    status: 1,
    sort: '',
    system_type: 1,
    set_meal_price: [{
      time: '',
      time_type: 1,
      price: ''
    }],
    func: [],
    func_mall: [],
    func_mes: []
  };

  mealModule = {
    marketing: [],
    apply: []
  }

  // 表单校验
  rules = {
    name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
    explain: [
      { required: true, message: '请输入套餐说明', trigger: 'blur' }
    ],
    system_type: [{ required: true, message: '请选择业务系统类型', trigger: 'change' }]
  };

  /** E Data **/

  /** S Methods **/
  handleSpecAdd () {
    if (this.form.set_meal_price.length >= 3) return this.$message.error('最多添加3条')
    this.form.set_meal_price.push({
      time: '',
      time_type: 1,
      price: ''
    })
  }

  handleSPecDel (index: number) {
    if (this.form.set_meal_price.length <= 1) return this.$message.error('最后一条不允许删除')
    this.form.set_meal_price.splice(index, 1)
  }

  mealTimeTypeChange (value: number, index: number) {
    if (value === 3) {
      this.form.set_meal_price[index].time = ''
    }
  }

  private getFuncKey () {
    return this.form.system_type === 2 ? 'func_mes' : 'func_mall'
  }

  private ensureFuncArray (key: string) {
    if (!Array.isArray(this.form[key])) {
      this.$set(this.form, key, [])
    }
  }

  isActiveModule (name: string) {
    const key = this.getFuncKey()
    this.ensureFuncArray(key)
    return this.form[key].includes(name)
  }

  // 点击表单提交
  onSubmit (formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.ensureFuncArray('func_mall')
      this.ensureFuncArray('func_mes')
      const key = this.getFuncKey()
      this.ensureFuncArray(key)
      this.form.func = this.form[key]

      if (!this.identity) {
        this.handleSetMealAdd()
      } else {
        this.handleSetMealEdit()
      }
    })
  }

  // 添加商城
  async handleSetMealAdd (): Promise<void> {
    await apiSetMealAdd({ ...this.form })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑商城
  async handleSetMealEdit (): Promise<void> {
    await apiSetMealEdit({ ...this.form, id: this.identity })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 获取详情
  async getSetMealDetailFunc (): Promise<void> {
    const res: any = await apiSetMealDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      if (res[key] === null || res[key] === undefined) return
      this.$set(this.form, key, res[key])
    })
    if (!Array.isArray(this.form.func_mall)) {
      this.$set(this.form, 'func_mall', Array.isArray(this.form.func) ? [...this.form.func] : [])
    }
    if (!Array.isArray(this.form.func_mes)) {
      this.$set(this.form, 'func_mes', Array.isArray(this.form.func_mall) ? [...this.form.func_mall] : [])
    }
  }

  @Watch('form.system_type')
  handleSystemTypeChange () {
    this.ensureFuncArray('func_mall')
    this.ensureFuncArray('func_mes')
    if (this.form.system_type === 1 && this.form.func_mall.length === 0 && this.form.func_mes.length > 0) {
      this.form.func_mall = [...this.form.func_mes]
    }
    if (this.form.system_type === 2 && this.form.func_mes.length === 0 && this.form.func_mall.length > 0) {
      this.form.func_mes = [...this.form.func_mall]
    }
    this.getMealModule()
  }

  getNewModuleItem (item: any) {
    if (item.is_required) {
      const requiredTypes = Array.isArray(item.required_system_types) ? item.required_system_types.map((v: any) => Number(v)) : []
      if (requiredTypes.includes(1)) {
        this.ensureFuncArray('func_mall')
        if (!this.form.func_mall.includes(item.en_name)) {
          this.form.func_mall.push(item.en_name)
        }
      }
      if (requiredTypes.includes(2)) {
        this.ensureFuncArray('func_mes')
        if (!this.form.func_mes.includes(item.en_name)) {
          this.form.func_mes.push(item.en_name)
        }
      }
      if (!requiredTypes.length) {
        const key = this.getFuncKey()
        this.ensureFuncArray(key)
        if (!this.form[key].includes(item.en_name)) {
          this.form[key].push(item.en_name)
        }
      }
    }
    return {
      ...item,
      image: config.baseURL + item.image
    }
  }

  async getMealModule () {
    const res = await apiMealModule({ system_type: this.form.system_type })
    this.mealModule.apply = res.apply.map(this.getNewModuleItem)
    this.mealModule.marketing = res.marketing.map(this.getNewModuleItem)
  }

  selectModule (menu: any) {
    if (menu.is_required) return
    const key = this.getFuncKey()
    this.ensureFuncArray(key)
    const otherKey = key === 'func_mall' ? 'func_mes' : 'func_mall'
    this.ensureFuncArray(otherKey)
    const index = this.form[key].findIndex((item: string) => item == menu.en_name)
    if (index != -1) {
      this.form[key].splice(index, 1)
      if (!this.identity) {
        const otherIndex = this.form[otherKey].findIndex((item: string) => item == menu.en_name)
        if (otherIndex != -1) this.form[otherKey].splice(otherIndex, 1)
      }
      return
    }
    this.form[key].push(menu.en_name)
    if (!this.identity && !this.form[otherKey].includes(menu.en_name)) {
      this.form[otherKey].push(menu.en_name)
    }
  }
  /** E Methods **/

  /** S Life Cycle **/
  async created () {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      await this.getSetMealDetailFunc()
    }
    this.getMealModule()
    this.onSubmit = throttle(this.onSubmit, 1000)
  }
  /** E Life Cycle **/
}
